import { render, staticRenderFns } from "./SalesParticipationChart.vue?vue&type=template&id=21074976"
import script from "./SalesParticipationChart.vue?vue&type=script&lang=js"
export * from "./SalesParticipationChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports